import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';
import { mapRetrieve } from '../common/rest.operators';

import {
    validateWidgetGroup,
    WidgetGroup,
    WidgetGroupModelTransformer,
} from './config.widget.model';
import { Widgets } from './widget.model';

@Injectable()
export class WidgetService {
    widgets: Widgets;

    constructor(
        private readonly _http: HttpClient,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {
        this.widgets = [];
    }

    widgetConfigurations(): Observable<WidgetGroup> {
        return this._http
            .get(`${this._appConfig.API_ENDPOINTS.USER}/widget-config/groups/1`)
            .pipe(
                mapRetrieve(new WidgetGroupModelTransformer()),
                tap((model: WidgetGroup) => validateWidgetGroup(model)),
                catchError((error) => {
                    console.error(error);
                    throw new Error('GetWidgetConfigurations failed');
                }),
            );
    }
}
